import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ListService, UserUserGroupListComponent, UserUserGroupListService } from '@spartacus/organization/administration/components';
import { EfaSubListComponent } from '../efa-sub-list/efa-sub-list.component';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'app-efa-user-user-group-list',
    templateUrl: './efa-user-user-group-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'content-wrapper' },
    providers: [
        {
            provide: ListService,
            useExisting: UserUserGroupListService,
        },
    ],
    imports: [EfaSubListComponent, RouterLink, TranslatePipe]
})
export class EfaUserUserGroupListComponent extends UserUserGroupListComponent implements OnInit {

  ngOnInit(): void {
  }

}
